import React, { type ReactNode, useCallback, useEffect } from "react";
import { CircularProgress, Stack } from "@mui/material";

// ** Store & Actions Imports
import { useDispatch } from "react-redux";
import type { AppDispatch } from "@/store";
import { setRoles } from "@/store/enums";
import { useGetRolesQuery } from "@/api/ExampleApi.ts";
import { useRouter } from "@tanstack/react-router";

type IEnumsContext = {
  children: ReactNode;
};

function EnumsContext({ children }: IEnumsContext) {
  const dispatch = useDispatch<AppDispatch>();
  const router = useRouter();
  const isAuthenticated = !!router.options.context.session?.isAuthenticated;
  const { data, isLoading, error } = useGetRolesQuery("", {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    if (data?.member) {
      dispatch(setRoles(data.member));
    }
  }, [data, dispatch]);

  if (!isAuthenticated) {
    return children;
  }

  if (isLoading || !data) {
    return (
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Stack>
    );
  }

  return children;
}

export default EnumsContext;
